import { inject, Injectable } from '@angular/core';
import { collection, Firestore, query, where } from '@angular/fire/firestore';
import { ObservableQueryService } from '@damofire/data-angular-commons';
import { ChangeTyped, MEDIAS_COLLECTION, WW_ISSUES_COLLECTION } from '@damofire/data-commons';
import { map, Observable } from 'rxjs';
import { ObservableIssueMediaService } from './issue-media-observable.service';
import { IdbIssueMedia } from './issue.dto';

@Injectable()
export class FirebaseObservableIssueMediaService extends ObservableIssueMediaService {
  private readonly firestore = inject(Firestore);

  constructor(private readonly firestoreQueryService: ObservableQueryService) {
    super();
  }

  observeMediaByIssue(division: string, issueId: string): Observable<ChangeTyped<IdbIssueMedia>[]> {
    const q = query(collection(this.firestore, `${WW_ISSUES_COLLECTION}/${issueId}/${MEDIAS_COLLECTION}`), where('division._id', '==', division));
    return this.firestoreQueryService.observeChanges(q).pipe(map((results) => results.sort((a, b) => Number(b.audit.createdDate) - Number(a.audit.createdDate))));
  }
}
